export const REGISTER_BEGIN = "REGISTER_BEGIN";
export const REGISTER_SUCCESS = "REGISTER_SUCESS";
export const REGISTER_FAILURE = "REGISTER_FAILURE";
